export const AI_EDITOR_PATH = '/ai';
export const THEME_AI_EDITOR_PATH = `/design${AI_EDITOR_PATH}`;

const AI_EDITOR_ROUTE = new RegExp(`/customize(/design)?${AI_EDITOR_PATH}/?$`);

export function isAIEditorPath(pathname) {
  return AI_EDITOR_ROUTE.test(pathname);
}

// Opened from Theme, the AI editor stays in Theme, so the sidebar keeps the theme sections.
export function aiEditorUrl(pageId, fromPathname = '') {
  const customize = `/pages/${pageId}/customize`;
  const inTheme = fromPathname.startsWith(`${customize}/design`);
  return `${customize}${inTheme ? THEME_AI_EDITOR_PATH : AI_EDITOR_PATH}`;
}
